import Form from './components/Form.vue';
import List from './components/List.vue';

export default {
  components: { Form, List },
  props: ['action_id', 'sale_id'],
  data() {
    return {
      addedProducts: [],
      formChanged: false,
      dialog: false,
      submitStatus: 'approved',
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    isManager() { return this.$store.getters.isManager; },
    isDealer() { return this.$store.getters.isDealer; },
    loading() { return this.$store.state.loading; },
    categoriesList() { return this.$store.state.sales.categoriesList || []; },
    isNewSale() { return (this.$props.sale_id === 'new' || this.$props.sale_id === 'null'); },
    validation() {
      return false;
    },
  },
  methods: {
    /**
     * Добавление товара в список
     * @param {object} product - объект добавляемого товара
     */
    AddProduct(product) {
      this.addedProducts.push(product);
    },
    /**
     * Удаленгие товара из списка
     * @param {string} idx - индекс удаляемого товара
     */
    RemoveProduct(idx) {
      this.addedProducts = this.addedProducts.filter(p => p.idx !== idx);
    },
    /**
     * Метод проверяющий что форма была изменена но не сохранена
     * @param {boolean} bool - признак изменения формы из компонента
     */
    ChangedForm(bool) {
      this.formChanged = bool;
    },
    /**
     * Подготовка данных к отправке или сохранению
     * @param {string} status - draft (черновик) или approved (новая продажа)
     */
    PrepareForm(status) {
      return {
        profile_id: this.user.profile_id,
        sale: {
          id: this.isNewSale ? null : this.$props.sale_id * 1,
          status,
          action_id: +this.$props.action_id,
        },
        positions: this.addedProducts.map((p, idx) => ({
          position: idx + 1,
          category_id: p.category.id,
          product_id: p.product.id,
          coating_id: p.coating ? p.coating.id : null,
          qty: p.qty,
        })),
      };
    },
    /**
     * Прелоадинг данных о редактируемой продаже
     * @param {object} sale - объект продажи
     */
    EditSalePrepare(sale) {
      this.addedProducts = sale.positions.map(p => ({
        product: p.product,
        category: p.product.category,
        bonuses: p.bonuses,
        qty: p.qty,
      }));
    },
    /** Закрытие диалога подтверждения сохранения */
    DialogClose() {
      this.submitStatus = 'approved';
      this.dialog = false;
    },
    /** Подтверждение отправки формы имея несохраненные данные */
    Agree() {
      this.dialog = false;
      this.OnSubmit();
    },
    /** Метод добавления новой продажи. */
    async OnSubmit() {
      const form = this.PrepareForm(this.submitStatus);
      const dispatchType = !this.isNewSale ? 'sales/UpdateSale' : 'sales/AddSale';
      await this.$store.dispatch(dispatchType, form)
        .then(() => this.$router.push('/sales'))
        .catch(e => console.warn(e));
    },
    /**
     * Метод добавления новой продажи.
     * @param {string} status - draft (черновик) или approved (новая продажа)
     */
    Save(status = 'approved') {
      this.submitStatus = status;
      if (this.formChanged) {
        this.dialog = true;
      } else {
        this.OnSubmit();
      }
    },
  },
  created() {
    if (this.isManager) {
      this.$router.push('/dashboard');
    } else {
      this.$store.dispatch('sales/GetCategories', {
        profile_id: this.user.profile_id,
        action_id: +this.$props.action_id,
      });
    }
  },
  async mounted() {
    if (!this.isNewSale) {
      await this.$store.dispatch('sales/GetSale', {
        profile_id: this.user.profile_id,
        sale_id: this.$props.sale_id,
      })
        .then(({ sale }) => this.EditSalePrepare(sale));
    }
  },
};
